import BaseProductViewModel from "@/models/Products/ProductViewModel";

export default class CreateProductViewModel extends BaseProductViewModel {
    newProductId: string = null;
}